import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {TweenLite} from "gsap";
import {CreepyCarnivalTwoGameConfig} from "../../CreepyCarnivalTwoGameConfig";
import {CreepyCarnivalTwoSoundConfig} from "../../CreepyCarnivalTwoSoundConfig";
import {CreepyCarnivalBulbsEvent} from "../../utils/CCTwoBulb";

export class CCTWildStarSpinView extends BaseView {

    private _img1:PIXI.Sprite;
    private _img2:PIXI.Sprite;
    private _staticWild1:PIXI.Sprite;
    private _staticWild2:PIXI.Sprite;
    private _wild_1:TimelineSprite;
    private _wild_1_win:TimelineSprite;
    private _wild_2:TimelineSprite;
    private _wild_2_win:TimelineSprite;
    private _layer:ScalableLayer;

    constructor() {
        super();
        this._layer = StageManager.getLayer(CreepyCarnivalTwoGameConfig.instance.LAYERS.WILD_STAR_SPIN.name);
        EventHandler.addEventListener(this, CreepyCarnivalBulbsEvent.SHOW_STAR_SPIN_BULBS, (event:GameEvent) => this.showWildSymAnimation());
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STOPPED, (event:GameEvent) => this.onReelsStopped());
    }

    protected initAnimations():void {
        this._wild_1 = new TimelineSprite(GameResources.getTextures("W/wild_attention/wild_attention_000"));
        this._wild_2 = new TimelineSprite(GameResources.getTextures("W/wild_attention/wild_attention_000"));
        this._wild_1.anchor.set(0.5, 0.5);
        this._wild_2.anchor.set(0.5, 0.5);
        this._wild_1.blendMode = PIXI.BLEND_MODES.ADD;
        this._wild_2.blendMode = PIXI.BLEND_MODES.ADD;

        this._img1 = new PIXI.Sprite(GameResources.getTextures("W/wild-frame")[0]);
        this._img2 = new PIXI.Sprite(GameResources.getTextures("W/wild-frame")[0]);
        this._img1.anchor.set(0.5, 0.5);
        this._img2.anchor.set(0.5, 0.5);
        this._staticWild1 = new PIXI.Sprite(GameResources.getTextures("W/W")[0]);
        this._staticWild2 = new PIXI.Sprite(GameResources.getTextures("W/W")[0]);
        this._staticWild1.anchor.set(0.5, 0.5);
        this._staticWild2.anchor.set(0.5, 0.5);
        // this.showWildSymAnimation();
    }

    private showWildSymAnimation():void {
        this._wild_1.position.set(489, 326);
        this._img1.position.set(489, 326);
        this._staticWild1.alpha = 0;
        this._img1.alpha = 1;
        this._img2.alpha = 1;
        this._staticWild2.alpha = 0;
        this._staticWild1.position.set(489, 326);
        this._img1.scale.set(7, 7);
        TweenLite.to(this._img1.scale, 0.5, {
            x : 1,
            y : 1,
            onComplete : () => {
                this._img1.alpha = 0;
                TweenLite.killTweensOf(this._img1);
            }
        });
        this._wild_2.position.set(793, 326);
        this._img2.position.set(793, 326);
        this._staticWild2.position.set(793, 326);
        this._img2.scale.set(7, 7);
        TweenLite.to(this._img2.scale, 0.5, {
            x : 1,
            y : 1,
            onComplete : () => {
                this._img2.alpha = 0;
                TweenLite.killTweensOf(this._img2);
            }
        });
        this._wild_1_win = new TimelineSprite(GameResources.getTextures("W/wild_attention/wild_attention_000"));
        this._wild_2_win = new TimelineSprite(GameResources.getTextures("W/wild_attention/wild_attention_000"));
        this._wild_1_win.anchor.set(0.5, 0.5);
        this._wild_2_win.anchor.set(0.5, 0.5);
        this._wild_1_win.blendMode = PIXI.BLEND_MODES.ADD;
        this._wild_2_win.blendMode = PIXI.BLEND_MODES.ADD;
        this._wild_1_win.position.set(489, 326);
        this._wild_2_win.position.set(793, 326);
        this._wild_1.visible = true;
        this._wild_2.visible = true;
        this._layer.addChild(this._wild_1);
        this._layer.addChild(this._wild_1_win);
        this._layer.addChild(this._img1);
        this._layer.addChild(this._staticWild1);
        this._layer.addChild(this._wild_2);
        this._layer.addChild(this._wild_2_win);
        this._layer.addChild(this._img2);
        this._layer.addChild(this._staticWild2);
        this._wild_1.getAnimation([0], function() {
        }, () => {
            //adding both the sound for 2 sticky wild for high volume
            SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.WILD_ATTENTION);
            SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.WILD_ATTENTION_2);
            this.playWildWinAnimation();
            this._wild_1.visible = false;
            this._wild_2.visible = false;
            this._staticWild1.alpha = 1;
        });
        this._wild_2.getAnimation([0]);
    }

    private playWildWinAnimation():void {
        this._wild_1_win.visible = true;
        this._wild_2_win.visible = true;
        this._wild_1_win.getAnimation([0], function() {
        }, () => {
            this._wild_1_win.visible = false;
            this._wild_2_win.visible = false;
            this._staticWild1.alpha = 1;
            this._staticWild2.alpha = 1;
        });
        this._wild_2_win.getAnimation([0]);
    }

    private onReelsStopped():void {
        this._staticWild1.alpha = 0;
        this._staticWild2.alpha = 0;
    }
}